import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, adminOnly = false }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const hasSessionToken = !!localStorage.getItem('session');
  
  console.log('ProtectedRoute Debug:', { isAuthenticated, user, adminOnly, hasSessionToken });

  // Check if user has a session token but Redux state is not updated yet
  if (!isAuthenticated && hasSessionToken) {
    console.log('User has session token but Redux state not updated, showing loading');
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('User not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !user?.isAdmin) {
    console.log('User not admin, redirecting to stream');
    return <Navigate to="/stream" replace />;
  }

  console.log('User authenticated, rendering component');
  return <Component />;
};

export default ProtectedRoute;